<div soho-busyindicator
     [style.height]="'100%'"
     [text]="' '"
     [blockUI]="true"
     [displayDelay]="20"
     [timeToComplete]="this.uiLoadingIndicatorTimeout"
     [transparentOverlay]="false"
>
  <ng-container *ngIf="isMultiRoot && (recordCount > 0 && initialSectionPerformed)">
    <div class="hyperlink-container">
      <button (click)="loadMultiRoot()" class="hyperlink">Back To Top</button>
    </div>
  </ng-container>

  <!-- Leaf template for hierarchy control -->
  <soho-hierarchy-leaf-template *ngIf="leafTemplate" [innerHtml]="leafTemplate"></soho-hierarchy-leaf-template>

  <ng-container *ngIf="recordCount > 0">
    <figure
        soho-hierarchy
        #SohoHierarchy
        *ngIf="data"
        [dataset]="data"
        [templateId]="leafTemplateId"
        [legend]="legend"
        [legendKey]="legendKey"
        [layout]="'stacked'"
        [attr.id]="hierarchyChartId"

        (selected)="onRowsSelected($event)"
        (doubleClick)="onDoubleClick($event)"
    >
    </figure>
  </ng-container>

  <div *ngIf="recordCount === 0 && (initialSectionPerformed || !allowFilterResults || isManualLoading() )" soho-emptymessage [emptyMessageOptions]="emptyMessage"></div>
</div>
